/**
 * Plain device frames (no brand marks) for showing the real app on the download page.
 * Pure markup and Tailwind: the screenshot inside is the only image.
 */

/** A desktop app window: thin title bar with hollow controls, then the screenshot. */
export function AppWindow({ src, alt, width = 1280, height = 720, className = '' }) {
  return (
    <div className={`relative ${className}`}>
      <div className="overflow-hidden rounded-[14px] border border-white/[0.14] bg-[#121018] shadow-[0_60px_140px_-40px_rgba(0,0,0,0.95),0_0_0_1px_rgba(255,255,255,0.03)]">
        <div className="flex h-9 items-center border-b border-white/10 bg-[#18181A] px-4">
          <div className="flex items-center gap-2" aria-hidden="true">
            <span className="h-2.5 w-2.5 rounded-full border border-white/30" />
            <span className="h-2.5 w-2.5 rounded-full border border-white/30" />
            <span className="h-2.5 w-2.5 rounded-full border border-white/30" />
          </div>
          <span
            className="mx-auto font-m1-mono text-[10px] uppercase tracking-[0.2em] text-m1-muted"
            aria-hidden="true"
          >
            M1NT
          </span>
          <span className="w-[42px]" aria-hidden="true" />
        </div>
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading="lazy"
          decoding="async"
          draggable="false"
          className="block h-auto w-full select-none"
        />
      </div>
      {/* Soft floor light under the window. */}
      <div
        className="pointer-events-none absolute -bottom-10 left-[8%] right-[8%] h-16 rounded-full bg-white/[0.06] blur-3xl"
        aria-hidden="true"
      />
    </div>
  )
}

/** A phone: dark bezel, camera island and the screenshot. */
export function PhoneFrame({ src, alt, width = 390, height = 844, className = '' }) {
  return (
    <div className={`relative ${className}`}>
      <div className="relative rounded-[46px] border border-white/[0.18] bg-[#0d0c11] p-[9px] shadow-[0_60px_120px_-30px_rgba(0,0,0,0.95),0_0_0_1px_rgba(255,255,255,0.03)]">
        <span
          className="absolute -left-[3px] top-[120px] h-9 w-[3px] rounded-l bg-white/20"
          aria-hidden="true"
        />
        <span
          className="absolute -left-[3px] top-[172px] h-14 w-[3px] rounded-l bg-white/20"
          aria-hidden="true"
        />
        <span
          className="absolute -right-[3px] top-[150px] h-20 w-[3px] rounded-r bg-white/20"
          aria-hidden="true"
        />
        <div className="relative overflow-hidden rounded-[37px] bg-black">
          <img
            src={src}
            alt={alt}
            width={width}
            height={height}
            loading="lazy"
            decoding="async"
            draggable="false"
            className="block h-auto w-full select-none"
          />
          <span
            className="absolute left-1/2 top-[10px] h-[22px] w-[78px] -translate-x-1/2 rounded-full bg-black"
            aria-hidden="true"
          />
        </div>
      </div>
      <div
        className="pointer-events-none absolute -bottom-8 left-[12%] right-[12%] h-12 rounded-full bg-white/[0.06] blur-3xl"
        aria-hidden="true"
      />
    </div>
  )
}
